const CircleIllustration = (props) => (
  <svg
    width={196}
    height={307}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="a"
      maskUnits="userSpaceOnUse"
      x={-60.188}
      y={-60.188}
      width={427.15}
      height={427.15}
      fill="#000"
    >
      <path fill="#fff" d="M-60.188-60.188h427.15v427.15h-427.15z" />
      <path d="M31.686 65.701C-16.74 132.915-1.513 226.66 65.701 275.088s160.959 33.199 209.387-34.015c48.428-67.213 33.199-160.959-34.015-209.387C173.86-16.742 80.114-1.513 31.686 65.701Zm240.967 173.618c-47.459 65.868-139.329 80.793-205.197 33.334C1.586 225.194-13.337 133.324 34.12 67.455 81.582 1.588 173.45-13.337 239.32 34.121c65.869 47.46 80.793 139.329 33.334 205.198Z" />
    </mask>
    <path
      d="M31.686 65.701C-16.74 132.915-1.513 226.66 65.701 275.088s160.959 33.199 209.387-34.015c48.428-67.213 33.199-160.959-34.015-209.387C173.86-16.742 80.114-1.513 31.686 65.701Zm240.967 173.618c-47.459 65.868-139.329 80.793-205.197 33.334C1.586 225.194-13.337 133.324 34.12 67.455 81.582 1.588 173.45-13.337 239.32 34.121c65.869 47.46 80.793 139.329 33.334 205.198Z"
      fill="#E96D6D"
    />
    <path
      d="M31.686 65.701C-16.74 132.915-1.513 226.66 65.701 275.088s160.959 33.199 209.387-34.015c48.428-67.213 33.199-160.959-34.015-209.387C173.86-16.742 80.114-1.513 31.686 65.701Zm240.967 173.618c-47.459 65.868-139.329 80.793-205.197 33.334C1.586 225.194-13.337 133.324 34.12 67.455 81.582 1.588 173.45-13.337 239.32 34.121c65.869 47.46 80.793 139.329 33.334 205.198Z"
      stroke="#E96D6D"
      strokeWidth={6}
      mask="url(#a)"
    />
  </svg>
);

export default CircleIllustration;
